import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import InventoryManagement from './inventoryManagementReducer';
import MasterData from './masterDataReducer';
import BarCodeData from './barCodeReducer';
import BulkUpload from './bulkUploadV2Reducer';
import ResourcePlanner from './resourcePlannerReducer';
import SlotPlanner from './slotPlannerReducer';
import Common from './commonReducer';
import KeyManagement from './keyManagement.reducer';
import UserManagement from './userManagementReducer';
import dndReducer from './dndReducer';
import fastagReducer from './fastagReducer';
import carCleaningReaducer from './carCleaningReducer';

export default combineReducers({
  form: formReducer,
  inventoryManagementReducer: InventoryManagement,
  masterDataReducer: MasterData,
  commonReducer: Common,
  barCodeReducer: BarCodeData,
  bulkUploadReducer: BulkUpload,
  resourcePlanner: ResourcePlanner,
  slotPlannerReducer: SlotPlanner,
  keyManagementReducer: KeyManagement,
  userManagementReducer: UserManagement,
  dnd: dndReducer,
  fastag: fastagReducer,
  carCleaning: carCleaningReaducer,
});

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
